import React, { useState, useEffect } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import { pdfPageCss } from "../../util/pdf/pdfCssStyles";
import { getCompanyCodeName } from "../../util/tableUtils";

const styles = StyleSheet.create(pdfPageCss);

export const PolicyDescriptionPdf = ({ policy, buildingHeight, roofarea, groundLevel, clientConfigData }) => {
  const { t } = useTranslation();

  const [policyAddress, setPolicyAddress] = useState("");

  useEffect(() => {
    if (policy) {
      const address = `${policy.addressStreetName ? policy.addressStreetName : ""} ${
        policy.addressBuildingNo ? policy.addressBuildingNo + "," : ""
      } ${policy?.addressCity ? policy.addressCity + "," : ""} ${
        policy?.addressZIPCode ? policy.addressZIPCode + "," : ""
      } ${policy?.addressProvince ? policy.addressProvince : ""}`;

      if (address.trim().length) {
        setPolicyAddress(address);
      } else {
        setPolicyAddress(
          getCompanyCodeName(policy.companyCode, clientConfigData.companyCodesMap) === "RMA"
            ? t("policy.addressNotAvailableRMA")
            : t("policy.addressNotAvailableITA"),
        );
      }
    }
  }, [policy, t]);

  return (
    <View style={styles.section}>
      <Text style={styles.subTitle}>{`${t("policy.id")}: ${policy.policyNumberSecondary}`}</Text>
      <Text style={styles.subTitle}>{`${t("idLocation")}: ${policy.multilocationID}`}</Text>
      <Text style={styles.subTitle}>{`${t("productGroup")}: ${policy.productSireGroup}`}</Text>
      <Text style={styles.subTitle}>{`${t("policy.buildingHeight")}: ${buildingHeight} m`}</Text>
      <Text style={styles.subTitle}>{`${t("policy.roofArea")}: ${roofarea} m² `}</Text>
      <Text style={styles.subTitle}>{`${t("policy.heightFromSea")}: ${groundLevel} m `}</Text>
      <Text style={styles.subTitle}>{`${t("latitude")}: ${policy.location.coordinates[1]}`}</Text>
      <Text style={styles.subTitle}>{`${t("longitude")}: ${policy.location.coordinates[0]}`}</Text>
      <Text style={styles.subTitle}>{`${t("address")}: ${policyAddress}`}</Text>
    </View>
  );
};
